import { useContext, useState } from 'react';
import { AppShell, Box } from '@mantine/core';
import TopNav from './Header';
import AppContext from './Context';

const MyApp = ({ children, paymentStatus, ticketId, totalSeconds }) => {
  const [opened, setOpened] = useState(false);
  const appContextState = useContext(AppContext);
  const { appState } = appContextState;

  const menuList = [
    { label: 'Home', path: '/home', id: '1' },
    { label: 'Refund', path: '/refund', id: '2' },
    { label: 'History', path: '/history', id: '3' },
  ];
  return (
    <AppShell
      styles={(theme) => ({
        root: {
          minHeight: '100vh',
        },
        main: {
          backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[8] : 'white',
          color: theme.colorScheme === 'dark' ? theme.colors.gray[1] : theme.colors.gray[8],
          padding: 0,
          overflowX: 'hidden',
          minHeight: 'calc(100vh - 292px)',
        },
      })}
      header={
        // <Header height={60} p="xs">
        //   <Group>
        //     <Text size="lg">New </Text>
        //     <Space w="lg" />
        //     <Text size="lg" onClick={() => navigate('/home')}>
        //       Home{' '}
        //     </Text>

        //     <Text size="lg" onClick={() => navigate('/refund')}>
        //       Refund{' '}
        //     </Text>

        //     <Text size="lg" onClick={() => navigate(''/history'')}>
        //       History{' '}
        //     </Text>

        //     <Text size="sm" ml="auto" onClick={() => '/login'}>
        //       CASHIER{' '}
        //     </Text>
        //   </Group>
        // </Header>
        <TopNav
          className="no-printme"
          opened={opened}
          setOpened={setOpened}
          hidden={opened}
          appState={appState}
          menuList={menuList}
          paymentStatus={paymentStatus}
          ticketId={ticketId}
          totalSeconds={totalSeconds}
        />
      }
    >
      <Box p="xl">{children}</Box>
    </AppShell>
  );
};

export default MyApp;
